import React from 'react';
import Marketplace, { Item } from './pages/Marketplace';
import LoginModal from './components/LoginModal';
import SearchBar from './components/SearchBar';
import FlashSaleGrid from './components/FlashSaleGrid';
import './App.css';

const App: React.FC = () => {

  const [loginOpen, setLoginOpen] = React.useState(false);
  const searchHandlerRef = React.useRef<(q: string) => void>(() => {});
  const [hasSearched, setHasSearched] = React.useState(false);
  const [searchResults, setSearchResults] = React.useState<Item[]>([]);
  const [searchLoading, setSearchLoading] = React.useState(false);
  const [searchError, setSearchError] = React.useState<string | null>(null);

  const resetSearchState = () => {
    setHasSearched(false);
    setSearchResults([]);
    setSearchLoading(false);
    setSearchError(null);
  };

  return (
    <div className="App">
      {/* Header */}
      <header className="App-header">
        <div className="header-left">
          <img src="/favicon.svg" alt="Logo" className="logo-icon-img" />
        </div>
        <div className="header-center">
          <SearchBar 
            onSearch={(q) => searchHandlerRef.current(q)}
            onQueryChange={(q) => {
              if (!q.trim()) {
                resetSearchState();
              }
            }}
          />
        </div>
        <div className="header-right">
          <button className="login-btn" onClick={() => setLoginOpen(true)}>Login</button>
        </div>
      </header>

      {/* Main Content */}
      <main>
        <div className="hero-section">
          <h1 className="hero-title">Today&apos;s Flash Sale</h1>
          <p className="hero-subtitle">Limited-time digital deals curated from global sources.</p>
          <FlashSaleGrid
            searchResults={searchResults}
            hasSearched={hasSearched}
            searchLoading={searchLoading}
            searchError={searchError}
          />
        </div>
        <Marketplace 
          onProvideSearch={(fn) => { searchHandlerRef.current = fn; }}
          onSearchStart={() => {
            setHasSearched(true);
            setSearchLoading(true);
            setSearchError(null);
          }}
          onSearchComplete={() => {
            // handled via onResults
          }}
          onResults={(items, loading, error) => {
            setSearchResults(items);
            setSearchLoading(loading);
            setSearchError(error);
          }}
          hideResults
        />
      </main>

      {/* Footer */}
      <footer className="App-footer">
        <div className="footer-container">
          <div className="footer-content">
            <div className="footer-section">
              <h3>About</h3>
              <p>
                An integrated search platform to help you discover the best offers across marketplaces.
              </p>
            </div>
            <div className="footer-section">
              <h3>Features</h3>
              <p><a href="#search">Product Search</a></p>
              <p><a href="#compare">Price Comparison</a></p>
              <p><a href="#reviews">Product Reviews</a></p>
              <p><a href="#deals">Best Deals</a></p>
            </div>
            <div className="footer-section">
              <h3>Support</h3>
              <p><a href="#help">Help Center</a></p>
              <p><a href="#faq">FAQ</a></p>
              <p><a href="#contact">Contact Us</a></p>
              <p><a href="#support">Support</a></p>
            </div>
            <div className="footer-section">
              <h3>Follow Us</h3>
              <p><a href="#facebook">Facebook</a></p>
              <p><a href="#twitter">Twitter</a></p>
              <p><a href="#instagram">Instagram</a></p>
              <p><a href="#linkedin">LinkedIn</a></p>
            </div>
          </div>
          <div className="footer-bottom">
            <p>&copy; 2024 Tokonex. All rights reserved. Built with ❤️ for digital seekers.</p>
          </div>
        </div>
      </footer>
      <LoginModal isOpen={loginOpen} onClose={() => setLoginOpen(false)} />
    </div>
  );
};

export default App;
